// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Matches_spinner__B4L_r"};